import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HttpErrorResponseVO } from 'src/app/core/api/v1';
import { NotificationService } from 'src/app/core/services/notification/notification.service';

export interface DisplayHttpErrorResponseVO extends HttpErrorResponseVO {
    status: number | null;
}

@Injectable()
export class HttpErrorService {
    constructor(
        private readonly messageService: MessageService,
        private readonly notificationService: NotificationService,
        private readonly ngZone: NgZone,
    ) {}

    public processResponseError(httpError: HttpErrorResponse): void {
        const status = httpError.status;
        if (status === 401) {
            this.ngZone.run(() => {
                this.notificationService.showError('Sie haben nicht die benötigten Berechtigungen!');
            });
        } else if (status === 409 && JSON.parse(httpError.error).hasOwnProperty('message')) {
            // 409 ist ein FachlicheException mit wichtiger message.
            this.ngZone.run(() => {
                this.notificationService.showError(JSON.parse(httpError.error).message);
            })
        } else if (status === 0) {
            this.ngZone.run(() => {
                this.notificationService.showError('Es ist ein Netzwerk Problem aufgetreten. Der Server ist vermutlich nicht erreichbar.');
            });
        } else {
            this.showErrorToast(httpError);
        }
    }

    private showErrorToast(httpError: HttpErrorResponse): void {
        let errorBody: unknown;
        let errorVO: DisplayHttpErrorResponseVO;
        try {
            errorBody = JSON.parse(httpError.error);
        } catch (parseError) {
            console.error('Error parsing error response', httpError.error, parseError);
        }

        if (errorBody && this.isHttpErrorResponseVO(errorBody)) {
            errorVO = errorBody as DisplayHttpErrorResponseVO;
        } else {
            let message = 'Unerwarteter Server-Fehler';
            if (errorBody && typeof errorBody == 'object' && 'message' in errorBody) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                message = (errorBody as any)['message'];
            } else if (typeof errorBody == 'string') {
                message = errorBody;
            } else if (errorBody != null) {
                try {
                    message = JSON.stringify(errorBody);
                } catch (e) {
                    console.error(e);
                }
            }
            errorVO = {
                timestamp: new Date().toDateString(),
                url: httpError.url,
                message,
                status: httpError.status,
            } as DisplayHttpErrorResponseVO;
        }
        errorVO.status = httpError.status;

        this.ngZone.run(() => {
            // this.messageService.clear('error');
            this.messageService.add({
                key: 'error',
                sticky: true,
                severity: 'error',
                data: errorVO,
            });
        });
    }

    private isHttpErrorResponseVO(obj: unknown): obj is HttpErrorResponseVO {
        return obj != null && typeof obj === 'object' && 'message' in obj && 'timestamp' in obj && 'url' in obj;
    }
}
